import curry from 'lodash/curry';
import isEmpty from 'lodash/isEmpty';
import pick from 'lodash/pick';
import { css, FlattenSimpleInterpolation } from 'styled-components';

import IThemeInterface from '../../Theme/common';

import { calcMediaStyles } from './CalcMediaStyles/calcMediaStyles';
import { VALID_MEDIA_MAP, VALID_PICKED_MEDIA } from './common';
import { makeMediaObj } from './makeMediaObj';
import { normalizeMediaStyles } from './normalizeMediaStyles';

export type VALID_DIMENSION = string | VALID_MEDIA_MAP;
export type VALID_DIMENSION_DATA = VALID_DIMENSION | { min?: VALID_DIMENSION; max?: VALID_DIMENSION };

export const calcDimensionStyles = curry((
  theme: IThemeInterface,
  kind: 'height' | 'width',
  dimension: VALID_DIMENSION_DATA
) => {

  if (typeof dimension === 'string') {
    return css`
      ${kind}: ${theme.containerSize[dimension] || dimension};
    `;
  }

  const styles: FlattenSimpleInterpolation[] = [];
  const pickedMedia: VALID_PICKED_MEDIA = makeMediaObj(dimension);
  // tslint:disable-next-line:no-any
  const pickedDimension: any = pick(dimension, ['min', 'max']);
  const normalizeMedia = normalizeMediaStyles(theme);

  if (!isEmpty(pickedMedia)) {
    const normalizedMedia: VALID_PICKED_MEDIA = normalizeMedia(pickedMedia, 'container');

    styles.push(css`
      ${calcMediaStyles(normalizedMedia, kind)};
    `);
  }

  if (!isEmpty(pickedDimension)) {
    const max = pickedDimension.max;
    const min = pickedDimension.min;

    if (typeof max === 'string') {
      styles.push(css`
        max-${kind}: ${theme.containerSize[max] || max};
      `);
    }

    if (typeof min === 'string') {
      styles.push(css`
        min-${kind}: ${theme.containerSize[min] || min};
      `);
    }

    if (typeof max === 'object') {
      const normalizedMedia: VALID_PICKED_MEDIA = normalizeMedia(max, 'container');

      styles.push(css`
        ${calcMediaStyles(normalizedMedia, `max-${kind}`)};
      `);
    }

    if (typeof min === 'object') {
      const normalizedMedia: VALID_PICKED_MEDIA = normalizeMedia(min, 'container');

      styles.push(css`
        ${calcMediaStyles(normalizedMedia, `min-${kind}`)};
      `);
    }
  }

  return styles;
});
